export enum ELazyModules {
	MODULE_MAIN_APP = 'moduleMainApp',
	MODULE_USERS = 'users',
	MODULE_HISTORY = 'history',
	MODULE_ACCESS_RIGHTS = 'accessRights',
	MODULE_ACCESS_RIGHT_VALUES = 'accessRightValues',
	MODULE_APP_VERSIONS = 'appVersions',
	MODULE_CUSTOMERS = 'customers',
	MODULE_CUSTOMER_APPS = 'customerApps'
}
